import * as React from 'react';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';
import {mediaBreakpointDown} from '../../../lib/styleVariables';
import BubbleDrawer, {canvasHeight} from './bubble-drawer';

type BackgroundBubblesProps = {
  className?: string;
  rotate?: number;
};
const START_ANIMATION_TIMEOUT = 2000;
const StyledCanvas = styled.canvas`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${canvasHeight.desktop}px;
  z-index: -99999;
  ${mediaBreakpointDown('tablet')} {
    height: ${canvasHeight.tablet}px;
  }
  ${mediaBreakpointDown('mobile')} {
    height: ${canvasHeight.mobile}px;
  }
`;

const BackgroundBubbles: React.FC<BackgroundBubblesProps> = props => {
  const canvasRef = React.useRef<HTMLCanvasElement>();
  const bubbleDrawerRef = React.useRef<BubbleDrawer>();
  const [isVisible, setIsVisible] = React.useState(false);

  React.useLayoutEffect(() => {
    if (canvasRef.current)
      bubbleDrawerRef.current = new BubbleDrawer(canvasRef.current, props.rotate);

    setTimeout(() => {
      if (bubbleDrawerRef.current)
        bubbleDrawerRef.current.init();
    }, START_ANIMATION_TIMEOUT);

    return () => {
      if (bubbleDrawerRef.current)
        bubbleDrawerRef.current.remove();
    };
  }, [props.rotate]);

  React.useEffect(() => {
    if (bubbleDrawerRef.current&&!isVisible)
      bubbleDrawerRef.current.stop();
  }, [isVisible]);

  React.useLayoutEffect(() => {
    if (bubbleDrawerRef.current&&isVisible)
      bubbleDrawerRef.current.start();
  }, [isVisible]);

  return (
    <VisibilitySensor
      onChange={setIsVisible}
      partialVisibility
      resizeThrottle={1000}
      scrollDelay={500}
      intervalDelay={1000}
    >
      <StyledCanvas ref={canvasRef as React.RefObject<HTMLCanvasElement>} className={props.className} />
    </VisibilitySensor>
  );
};

export default BackgroundBubbles;
